import React from 'react';
import CompanyForm from '../components/company/CompanyForm';
import Alert from '../components/ui/Alert';

const CompanyPage: React.FC = () => {
    return (
        <div className="container">
            <div className="header">
                <h1>🏢 Company Information</h1>
                <p>Update your company details</p>
            </div>

            <div className="form-container">
                <Alert />
                <CompanyForm />
            </div>
        </div>
    );
};

export default CompanyPage;

